<div class="sms-verification-container">
  <header>
    <div class="sms-verification-navbar d-flex align-items-center">
      <a class="navbar-brand" href="/"><img src="./assets/images/logo-horizontal.svg" width="175"
          alt="Fisher Shipping Logo" /></a>
      <div class="header-text ml-3">
        <div class="navbar-title">FisherShipping TMS</div>
        <div class="navbar-subtitle">SMS Verification Information & Consent</div>
      </div>
    </div>
  </header>

  <div class="sms-content-container">
    <section class="sms-head">
      <h2 class="f-w-bold">SMS Verification During Login (2FA)</h2>
      <p class="sms-para">
        We use SMS-based one-time passwords (OTP) to help secure user accounts.
        SMS messages are sent <strong>only</strong> when a user initiates a login and requests verification.
      </p>
    </section>

    <section class="sms-card-section">
      <div class="sms-card-details">
        <div class="d-flex justify-content-between align-items-center sms-card-header">
          <h3 class="f-w-bold">How It Works</h3>
          <span class="sms-badge">
            Use Case: <strong>2FA / Account Verification</strong>
          </span>
        </div>
        <div class="sms-card-content">
          <ol class="steps">
            <li>User enters their username and password on the login screen.</li>
            <li>If the credentials are valid, the system sends a one-time verification code by SMS to the phone number
              already associated with the user's profile.</li>
            <li>User is redirected to an OTP screen to enter the verification code (or request a new code).</li>
            <li>After successful code entry, the user is logged in.</li>
          </ol>

          <div class="note">
            <strong>Consent Notice:</strong> OTP messages are sent only in response to a user-initiated login attempt.
            We do not send promotional or marketing SMS messages.
          </div>

          <div class="sms">
            <p class="label">Example SMS Message</p>
            <pre>Your FisherShipping TMS verification code is: 123456. This code will expire in 10 minutes.</pre>
            <p class="small">
              (In production, the numeric code is generated automatically and expires after a short period.)
            </p>
          </div>
        </div>
      </div>

      <div class="sms-card-details">
        <div class="d-flex justify-content-between align-items-center sms-card-header">
          <h3>Login Verification(Non-Functional)</h3>
        </div>
        <div class="sms-card-content">
          <p style="color:#64748b;">
            The phone number is already saved in the user profile. Below is a disabled illustration of the flow (no OTP
            is sent from this page).
          </p>

          <div class="sms-form" role="form">
            <div class="sms-field">
              <label for="phone">User Name</label>
              <input id="text" type="text" placeholder="" disabled />
            </div>
            <div class="sms-field">
              <label for="phone">Password</label>
              <input id="text" type="text" placeholder="" disabled />
            </div>
            <div class="sms-btns">
              <button class="primary" type="button" disabled>Log in</button>
              <button type="button" disabled>Reset Password</button>
            </div>
          </div>

          <hr>
          <div class="sms-additional-notes">
            <h4>Additional Notes</h4>
            <ul class="sms-bullets">
              <li>Messages are transactional and security-related (2FA/OTP only).</li>
              <li>Users can request a new code from the OTP screen during the login session.</li>
              <li>No links, promotions, or marketing content are included in OTP messages.</li>
            </ul>
            <p class="sms-help-section">
              Need help? Contact support at <a
                href="mailto:support&#64;fishershipping.com">info&#64;fishershipping.com</a>.
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>